var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVPcLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "kdu0u41iua"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -29)",
    filter: "url(#kdu0u41iua)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.25 34.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#C8CBD4",
    strokeWidth: 2,
    x: 12,
    y: 33,
    width: 21,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8CBD4",
    strokeWidth: 2,
    d: "M17 28h11v5H17zM4 0h36a4 4 0 0 1 4 4v18H0V4a4 4 0 0 1 4-4zM0 22h44v2a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C8CBD4",
    cx: 22.5,
    cy: 24.5,
    r: 1
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C8CBD4"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.472,
    y: 15
  }, "vPC"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVPcLine);
export default __webpack_public_path__ + "static/media/ico-v-pc-line.2b5b82020758e722b04ba97f56506072.svg";
export { ForwardRef as ReactComponent };